import { FieldsDefinition, Form, FormDefinition } from '@lbmx/per-form';

export const formDefinition = (
  fields: FieldsDefinition<Form>
): FormDefinition<any> => ({
  fields,
});
